export const OnboardingMenuList = [
  {
    id: 1,
    label: 'Detail',
  },
  {
    id: 2,
    label: 'Assignies',
  },
  {
    id: 3,
    label: 'Qualification',
  },
];

export const OnboardingMenuConst = {
  DETAIL: 1,
  ASSIGNIES: 2,
  QUALIFICATION: 3,
};
